import { AppWindow, Button, Maximize2, Minus, Pin, PinOff, X } from "@repo/ui";

export type WindowControlsProps = {
  isMinimized: boolean;
  isPinned: boolean;
  onClose: () => void;
  onMinimize: () => void;
  onPin: () => void;
};

export const WindowControls = ({
  isMinimized,
  isPinned,
  onClose,
  onMinimize,
  onPin,
}: WindowControlsProps) => {
  return (
    <div className="flex items-center gap-1">
      <Button
        icon={<X className="h-4 w-4" />}
        variant="outline"
        align="center"
        justify="center"
        onClick={onClose}
        className="rounded-full"
        title="Close"
      />
      <Button
        icon={isMinimized ? <Maximize2 className="h-4 w-4" /> : <Minus className="h-4 w-4" />}
        variant="outline"
        align="center"
        justify="center"
        onClick={onMinimize}
        className="rounded-full"
        title={isMinimized ? "Maximize" : "Minimize"}
      />
      <Button
        icon={<AppWindow className="h-4 w-4" />}
        variant="outline"
        align="center"
        justify="center"
        className="rounded-full"
        title="Open as window"
      />
      <Button
        icon={isPinned ? <PinOff className="h-4 w-4" /> : <Pin className="h-4 w-4" />}
        variant={isPinned ? "secondary" : "outline"}
        align="center"
        justify="center"
        onClick={onPin}
        className="rounded-full"
        title={isPinned ? "Unpin" : "Pin"}
      />
    </div>
  );
};
